import React, { memo, useCallback, useMemo } from 'react';
import cn from 'classnames';
import { HeaderWrapper, HeaderRow } from '@creditflowresearch/uilib/Table/DataTable';
import {
  getLegendHeaderColumns,
  getYearHeaderColumns,
} from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/helpers';
import { IColumnScorecard } from '@/creditflowresearch/application/League/interfaces';
import { IPeriod } from '@/creditflowresearch/domain/vo/League/IStandings';

import standingStyles from '@/creditflowresearch/ui/components/league/Scorecard/StandingTable/standingTable.module.scss';

interface IProps {
  hasAmount: boolean,
  periods: IPeriod[],
}

const Header = ({
  periods,
  hasAmount,
}: IProps) => {
  const getLegendCell = useCallback(() => (
    <span
      className={ cn(
        standingStyles.wrapperHeaderCell,
        { [standingStyles.withoutAmount]: !hasAmount },
      ) }
    >
      #
      { hasAmount && <span className={ standingStyles.amountCell }>$M</span> }
    </span>
  ), [hasAmount]);

  const getYearCell = useCallback(({ title }: IColumnScorecard) => (
    <span
      className={ cn(
        standingStyles.wrapperHeaderCell,
        { [standingStyles.withoutAmount]: !hasAmount },
      ) }
    >
      { title }
    </span>
  ), [hasAmount]);

  const headerColumns = useMemo(
    () => getYearHeaderColumns(periods, getYearCell),
    [
      periods,
      getYearCell,
    ],
  );
  const legendColumns = useMemo(() => getLegendHeaderColumns(periods, getLegendCell), [periods, getLegendCell]);
  return (
    <HeaderWrapper>
      <HeaderRow key="header" columns={ headerColumns } />
      <HeaderRow key="legend" columns={ legendColumns } />
    </HeaderWrapper>
  );
};

export default memo(Header);
